import { graphql, OptionProps } from 'react-apollo';
import { CompositeComponent } from '../types';
import { LoggedInUserQuery } from './queries';
import { LoggedInUserPayload, User } from './types';

export interface LoggedInUserProps {
    loggedInUser?: User;
    loading?: boolean;
    error?: any;
}

export function withLoggedInUser<TProps extends {}>(
    WrappedComponent: CompositeComponent<TProps & LoggedInUserProps>
) {
    return graphql<TProps, LoggedInUserPayload, {}, TProps & LoggedInUserProps>(
        LoggedInUserQuery,
        {
            props: (
                props: OptionProps<TProps, LoggedInUserPayload>
            ): TProps & LoggedInUserProps => {
                const { data } = props;
                if (data) {
                    const { loggedInUser, error, loading } = data;
                    const result = {
                        ...(props.ownProps as any),
                        error,
                        loading,
                        loggedInUser: loggedInUser
                            ? loggedInUser.user
                            : undefined
                    };
                    return result;
                }
                throw new Error('No logged in user provided');
            }
        }
    )(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/client/components/Login/withLoggedInUser.tsx